import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, CheckSquare, Square, Download, Printer } from 'lucide-react';
import './GuidePage.css';

export default function PacklistChecklist() {
  const [checkedItems, setCheckedItems] = useState({});

  const toggleItem = (id) => {
    setCheckedItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const categories = [
    {
      name: 'Kleidung - Zwiebelprinzip',
      items: [
        { id: 'baselayer1', text: 'Merino-Funktionsshirt langarm (2-3 Stück)' },
        { id: 'baselayer2', text: 'Funktionsunterhose (2-3 Stück)' },
        { id: 'midlayer1', text: 'Fleece-Jacke oder Softshell' },
        { id: 'midlayer2', text: 'Weste (für Abfahrten)' },
        { id: 'shell1', text: 'Regenjacke (wasserdicht & atmungsaktiv)' },
        { id: 'shell2', text: 'Regenhose (Überziehhose)' },
        { id: 'shell3', text: 'Windjacke (leicht)' }
      ]
    },
    {
      name: 'Radbekleidung',
      items: [
        { id: 'bike1', text: 'Radhose mit Polster (2 Stück minimum!)' },
        { id: 'bike2', text: 'Radtrikots (2-3 Stück)' },
        { id: 'bike3', text: 'Arm- & Beinlinge (flexibel kombinierbar)' },
        { id: 'bike4', text: 'Radhandschuhe - kurz (gepolstert)' },
        { id: 'bike5', text: 'Radhandschuhe - lang (für kühlere Tage)' }
      ]
    },
    {
      name: 'Accessoires',
      items: [
        { id: 'acc1', text: 'Buff/Halstuch (gegen Wind, Sonne, Midges!)' },
        { id: 'acc2', text: 'Mütze/Cap (unter Helm bei Kälte)' },
        { id: 'acc3', text: 'Merino-Socken (3-4 Paar)' },
        { id: 'acc4', text: 'Sonnenbrille/Radbrille (UV-Schutz)' },
        { id: 'acc5', text: 'Reflektierende Weste' }
      ]
    },
    {
      name: 'Helm & Sicherheit',
      items: [
        { id: 'safety1', text: 'Fahrradhelm (CE-zertifiziert)' },
        { id: 'safety2', text: 'Frontlicht (mind. 300 Lumen)' },
        { id: 'safety3', text: 'Rücklicht (Blink- & Dauerlicht)' },
        { id: 'safety4', text: 'Ersatzbatterien/Akkus für Lichter' }
      ]
    },
    {
      name: 'Taschen & Gepäck',
      items: [
        { id: 'bag1', text: 'Satteltasche (Werkzeug & Ersatzteile)' },
        { id: 'bag2', text: 'Rahmentasche (Snacks, Handy)' },
        { id: 'bag3', text: 'Lenkertasche (Karte, wasserdicht)' },
        { id: 'bag4', text: 'Gepäckträger-Taschen (Ortlieb o.ä., wasserdicht!)' },
        { id: 'bag5', text: 'Packsäcke (für Organisation innen)' }
      ]
    },
    {
      name: 'Navigation & Elektronik',
      items: [
        { id: 'nav1', text: 'GPS-Gerät oder Smartphone mit Halterung' },
        { id: 'nav2', text: 'Offline-Karten heruntergeladen' },
        { id: 'nav3', text: 'Powerbank (mind. 10.000 mAh)' },
        { id: 'nav4', text: 'Ladekabel (USB-C, Lightning, Micro-USB)' },
        { id: 'nav5', text: 'UK-Adapter (Typ G) - mind. 2 Stück!' }
      ]
    },
    {
      name: 'Trinkflaschen & Verpflegung',
      items: [
        { id: 'food1', text: '2x Trinkflaschen (je 750ml)' },
        { id: 'food2', text: 'Energieriegel (10-15 Stück)' },
        { id: 'food3', text: 'Nüsse & Trockenfrüchte' },
        { id: 'food4', text: 'Elektrolyt-Pulver/Tabletten' }
      ]
    },
    {
      name: 'Werkzeug & Reparatur (MUSS dabei sein!)',
      items: [
        { id: 'tool1', text: 'Multi-Tool (Inbus, Schraubendreher, Kettennieter)' },
        { id: 'tool2', text: 'Reifenheber (2-3 Stück)' },
        { id: 'tool3', text: 'Ersatzschlauch (2 Stück minimum!)' },
        { id: 'tool4', text: 'Flickzeug (Patch-Kit)' },
        { id: 'tool5', text: 'Mini-Pumpe oder CO2-Kartuschen (3-5 Stück)' },
        { id: 'tool6', text: 'Kettenschloss (Ersatz)' },
        { id: 'tool7', text: 'Kettenöl (kleine Flasche)' },
        { id: 'tool8', text: 'Lappen/Tuch' },
        { id: 'tool9', text: 'Kabelbinder (10 Stück)' },
        { id: 'tool10', text: 'Isolierband' }
      ]
    },
    {
      name: 'E-Bike Zusatzausrüstung',
      items: [
        { id: 'ebike1', text: 'Ladegerät (Original vom Hersteller)' },
        { id: 'ebike2', text: 'UK-Adapter (zusätzlich, speziell fürs Ladegerät)' },
        { id: 'ebike3', text: 'Ersatz-Akku (wenn möglich - teuer aber sicher)' },
        { id: 'ebike4', text: 'Akku-Abdeckung (gegen Regen)' }
      ]
    },
    {
      name: 'Erste Hilfe & Notfall',
      items: [
        { id: 'med1', text: 'Erste-Hilfe-Set (Pflaster, Verbände, Desinfektionsmittel)' },
        { id: 'med2', text: 'Schmerzmittel (Ibuprofen o.ä.)' },
        { id: 'med3', text: 'Sonnencreme (SPF 30+)' },
        { id: 'med4', text: 'Zeckenzange' },
        { id: 'med5', text: 'Blasenpflaster (Compeed o.ä.)' },
        { id: 'med6', text: 'Persönliche Medikamente' }
      ]
    },
    {
      name: 'Schottland-Spezial: Midges!',
      items: [
        { id: 'midge1', text: 'Midge-Netz für Kopf (ABSOLUT NÖTIG!)' },
        { id: 'midge2', text: 'Smidge-Spray (spezielles Midge-Repellent)' },
        { id: 'midge3', text: 'Lange Kleidung auch bei Hitze (Schutz)' }
      ]
    },
    {
      name: 'Hygiene & Persönliches',
      items: [
        { id: 'hygiene1', text: 'Zahnbürste & Zahnpasta' },
        { id: 'hygiene2', text: 'Reisehandtuch (Mikrofaser, schnelltrocknend)' },
        { id: 'hygiene3', text: 'Seife/Duschgel (klein)' },
        { id: 'hygiene4', text: 'Shampoo (klein)' },
        { id: 'hygiene5', text: 'Deo' },
        { id: 'hygiene6', text: 'Rasierer (optional)' },
        { id: 'hygiene7', text: 'Lippenbalsam (Wind!)' }
      ]
    },
    {
      name: 'Dokumente & Geld',
      items: [
        { id: 'doc1', text: 'Reisepass/Personalausweis' },
        { id: 'doc2', text: 'EHIC (Europäische Krankenversicherungskarte)' },
        { id: 'doc3', text: 'Reiseversicherung Unterlagen' },
        { id: 'doc4', text: 'Kreditkarte & Bargeld (£100-200)' },
        { id: 'doc5', text: 'Notfall-Kontakte (ausgedruckt!)' }
      ]
    },
    {
      name: 'Optional / Nice-to-Have',
      items: [
        { id: 'opt1', text: 'Kamera / Action-Cam' },
        { id: 'opt2', text: 'Tagebuch & Stift' },
        { id: 'opt3', text: 'Fernglas (Wildlife!)' },
        { id: 'opt4', text: 'Bücher/E-Reader' },
        { id: 'opt5', text: 'Ohrstöpsel (laute B&Bs!)' },
        { id: 'opt6', text: 'Wäscheleine + Klammern' }
      ]
    }
  ];

  const checkedCount = Object.values(checkedItems).filter(Boolean).length;
  const totalCount = categories.reduce((sum, cat) => sum + cat.items.length, 0);

  return (
    <div className="guide-page">
      <Link to="/wissen" className="back-link"><ArrowLeft size={20} /> Zurück zum Wissen</Link>
      
      <article className="guide-content">
        <h1>✅ Packliste für Schottland-Radtouren</h1>
        
        <div className="info-box">
          <p>
            <strong>Interaktive Checkliste:</strong> Klicke auf die Items, um sie abzuhaken! 
            Dein Fortschritt: <strong>{checkedCount} / {totalCount}</strong> Punkte erledigt.
          </p>
        </div>

        <div className="pro-tip" style={{ marginBottom: '30px' }}>
          <h3>💡 Packtipps für Schottland</h3>
          <ul>
            <li><strong>Weniger ist mehr:</strong> Max. 7-8kg Gepäck (ohne Rad)</li>
            <li><strong>Wasserdichtigkeit ist KRITISCH:</strong> Regen ist garantiert!</li>
            <li><strong>Midges-Schutz nicht vergessen:</strong> Mai-September = Pflicht!</li>
            <li><strong>UK-Adapter kaufen:</strong> Typ G (3 Pins) - mind. 2 Stück!</li>
          </ul>
        </div>

        {categories.map((category, idx) => (
          <section key={idx}>
            <h2>{category.name}</h2>
            <div className="checklist">
              {category.items.map(item => (
                <div 
                  key={item.id} 
                  className="check-item" 
                  onClick={() => toggleItem(item.id)}
                  style={{ 
                    cursor: 'pointer', 
                    opacity: checkedItems[item.id] ? 0.6 : 1,
                    textDecoration: checkedItems[item.id] ? 'line-through' : 'none'
                  }}
                >
                  {checkedItems[item.id] ? <CheckSquare size={20} /> : <Square size={20} />}
                  {item.text}
                </div>
              ))}
            </div>
          </section>
        ))}

        <section>
          <h2>Saisonale Anpassungen</h2>
          
          <h3>🌞 Sommer (Juni - August)</h3>
          <ul>
            <li>✅ Regenjacke & Überhose (immer!)</li>
            <li>✅ Lange Ärmel (Sonnenschutz & Midges)</li>
            <li>✅ Midge-Netz & Spray (ABSOLUTES MUSS!)</li>
            <li>⚠️ Warme Kleidung (Abende können kühl sein, 10-15°C)</li>
          </ul>

          <h3>🍂 Herbst/Frühling (April-Mai, Sept-Okt)</h3>
          <ul>
            <li>✅ Alles vom Sommer +</li>
            <li>✅ Warme Jacke (Fleece + Windjacke)</li>
            <li>✅ Lange Radhose</li>
            <li>✅ Mütze & warme Handschuhe</li>
          </ul>

          <h3>❄️ Winter (Nov-März) - Nur für Hartgesottene!</h3>
          <ul>
            <li>✅ Winterkleidung komplett</li>
            <li>✅ Spike-Reifen für Eis (optional)</li>
            <li>✅ Stirnlampe (kurze Tage!)</li>
            <li>⚠️ Viele Unterkünfte geschlossen - vorher prüfen!</li>
          </ul>
        </section>

        <div className="warning-box">
          <h3>⚠️ Häufige Packfehler vermeiden!</h3>
          <ul>
            <li><strong>Zu viel Gepäck:</strong> Über 10kg = unnötiges Leiden bei Anstiegen</li>
            <li><strong>Falsche Regenkleidung:</strong> Billige Regenjacke = du wirst nass!</li>
            <li><strong>Keine Midges-Vorbereitung:</strong> Im Sommer = Hölle ohne Schutz!</li>
            <li><strong>Zu wenig Ersatzteile:</strong> Nächster Bike-Shop kann 80km entfernt sein</li>
            <li><strong>UK-Adapter vergessen:</strong> Kann man kaufen, aber teuer!</li>
          </ul>
        </div>

        <div className="download-section">
          <h3>📥 Checkliste als PDF herunterladen</h3>
          <p>Drucke die Checkliste aus oder speichere sie als PDF auf deinem Gerät!</p>
          <button className="download-btn" onClick={() => window.print()}>
            <Download size={20} /> Als PDF speichern/drucken
          </button>
          <button className="download-btn" style={{ marginLeft: '10px' }} onClick={() => window.print()}>
            <Printer size={20} /> Seite drucken
          </button>
        </div>

        <div className="info-box">
          <h4>📚 Weiterführende Guides</h4>
          <ul>
            <li><Link to="/wissen/ausruestung">🎒 Ausrüstungs-Guide</Link> - Detaillierte Infos zu jedem Item</li>
            <li><Link to="/wissen/ebike">⚡ E-Bike Basics</Link> - E-Bike spezifische Ausrüstung</li>
            <li><Link to="/wissen/checklist/bike">🔧 Bike-Check Checkliste</Link> - Rad vorbereiten</li>
          </ul>
        </div>
      </article>
    </div>
  );
}
